import React from "react";
import useAuth from "../hooks/useAuth";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";

export default function NavigateToIfAuth(Component, route) {
  return function AuthenticatedComponent(props) {
    AuthenticatedComponent.propTypes = {
      children: PropTypes.node,
    };
    const { token } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
      if (token) {
        navigate(route);
      }
    }, [token]);
    return <Component {...props} />;
  };
}
